import React, { useContext } from 'react';
import styled from 'styled-components';
import { Particles as ReactParticles } from 'react-tsparticles';
import { DEFAULT, AMONG_US, TECH_LOGOS, NYAN_CAT, SNOW, TRAILS, BACKGROUND, MATRIX, PENTAGONS } from './particles-presets';

import { AppContext } from './../App/AppContext';

const P = {
  Container: styled.div`
    transition: background-color 0.5s linear;
    position: absolute;
    background-color: ${({ theme }) => theme.background};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    z-index: 0;
  `,
};

export const Particles = () => {
  const { theme } = useContext(AppContext);

  let presets = [DEFAULT, AMONG_US, TECH_LOGOS, NYAN_CAT, SNOW, TRAILS, BACKGROUND, MATRIX, PENTAGONS];

  let CHOSEN = presets[Math.floor(Math.random() * presets.length)]

  return (
    <P.Container theme={theme}>
      <ReactParticles width='100vw' height='100vh' options={MATRIX}/>
    </P.Container>
  );
};
